export default __webpack_public_path__ + "static/media/header_texture_01SC.da29cb25.png";